{
  "blocks": [
    {
      "id": "proc-doppler-ultrasound",
      "kind": "procedure",
      "tags": ["testing", "her", "clinic-visit"],
      "title": "Doppler ultrasound",
      "subtitle": "Ultrasound that measures blood flow to the uterus and ovaries",
      "body": {
        "procedureName": "Doppler ultrasound",
        "category": "diagnostic",
        "description": "A specialized ultrasound that uses Doppler technology to evaluate blood flow in the uterine and ovarian arteries. Healthy blood flow is important for implantation and follicle development.",
        "howItWorks": "The exam is performed similarly to a transvaginal or transabdominal ultrasound, but with an added Doppler mode that detects the speed and direction of blood flow. The probe sends out sound waves that bounce off moving red blood cells, producing color-coded images and audible signals. The doctor measures resistance indices in the uterine arteries and ovarian vessels to assess whether blood supply to the endometrium and follicles is adequate. Poor blood flow may prompt adjustments to your treatment plan.",
        "duration": "15–25 minutes",
        "anesthesia": "none",
        "painAndComfort": [
          "The exam feels like a standard ultrasound, with mild pressure or brief discomfort from the probe."
        ],
        "whatToExpect": [
          "The exam feels the same as a standard ultrasound, with no added discomfort",
          "You may hear a pulsing or whooshing sound from the Doppler signal",
          "Color-coded images on the screen show blood flow patterns",
          "Results are usually discussed right away or at your next visit"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "Doppler findings are often discussed right away because blood flow is measured during the scan."
          },
          {
            "label": "What you learn",
            "detail": "Your clinician may review uterine or ovarian blood flow patterns and whether they affect the current plan."
          },
          {
            "label": "Follow-up",
            "detail": "If blood flow looks concerning, your doctor may adjust monitoring, medication, or timing."
          }
        ],
        "prepInstructions": [
          "Follow the same preparation as for a transvaginal or transabdominal ultrasound",
          "No fasting or special diet is required",
          "Inform your clinic of any blood-thinning medications you take"
        ],
        "risks": [
          "No known risks: Doppler ultrasound is non-invasive and radiation-free",
          "Mild pressure or discomfort from the probe"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Échographie Doppler",
          "description": "Échographie spécialisée utilisant la technologie Doppler pour évaluer la vascularisation des artères utérines et ovariennes. Un bon flux sanguin est important pour l'implantation et le développement folliculaire.",
          "howItWorks": "L'examen se déroule comme une échographie endovaginale ou sus-pubienne, avec un mode Doppler en complément qui détecte la vitesse et la direction du flux sanguin. La sonde émet des ondes sonores qui se réfléchissent sur les globules rouges en mouvement, produisant des images en code couleur et des signaux audibles. Le médecin mesure les indices de résistance dans les artères utérines et les vaisseaux ovariens pour évaluer si l'apport sanguin à l'endomètre et aux follicules est suffisant. Un flux insuffisant peut conduire à ajuster votre protocole.",
          "duration": "15 à 25 minutes",
          "whatToExpect": [
            "L'examen est ressenti comme une échographie standard, sans inconfort supplémentaire",
            "Vous pouvez entendre un son pulsé ou un sifflement provenant du signal Doppler",
            "Des images en couleur à l'écran montrent les flux sanguins",
            "Les résultats sont généralement discutés immédiatement ou lors du prochain rendez-vous"
          ],
          "results": [
            {
              "label": "Quand vous avez des nouvelles",
              "detail": "Les résultats Doppler sont souvent discutés immédiatement, car le flux sanguin est mesuré pendant l'examen."
            },
            {
              "label": "Ce que vous apprenez",
              "detail": "Votre clinicien peut revoir les flux utérins ou ovariens et dire s'ils modifient le plan en cours."
            },
            {
              "label": "Suivi",
              "detail": "Si le flux paraît préoccupant, votre médecin peut ajuster le suivi, les médicaments ou le timing."
            }
          ],
          "prepInstructions": [
            "Suivez la même préparation que pour une échographie endovaginale ou sus-pubienne",
            "Aucun jeûne ni régime particulier nécessaire",
            "Informez votre centre de tout traitement anticoagulant en cours"
          ],
          "risks": [
            "Aucun risque connu : l'échographie Doppler est non invasive et sans rayonnement",
            "Légère pression ou inconfort dû à la sonde"
          ]
        }
      },
      "sources": [
        {
          "title": "AIUM Practice Parameter for Ultrasound Examinations in Reproductive Medicine",
          "authors": "American Institute of Ultrasound in Medicine",
          "journal": "AIUM",
          "year": 2020,
          "url": "https://www.aium.org/docs/default-source/resources/guidelines/reproductiveMed.pdf",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
